import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hint", "form"]
  static values = { minLength: Number, delay: Number, focusKey: String }

  connect() {
    this.debounceTimer = null
    this.updateHint()
    this.restoreFocus()
  }

  search() {
    const query = this.inputTarget.value.trim()
    const minLength = this.minLengthValue || 3

    if (query.length > 0 && query.length < minLength) {
      this.showHint()
      return
    }

    this.hideHint()
    window.clearTimeout(this.debounceTimer)
    this.debounceTimer = window.setTimeout(() => {
      if (this.hasFormTarget) {
        this.rememberFocus()
        this.formTarget.requestSubmit()
      }
    }, this.delayValue || 300)
  }

  updateHint() {
    const query = this.inputTarget.value.trim()
    const minLength = this.minLengthValue || 3
    if (query.length > 0 && query.length < minLength) {
      this.showHint()
    } else {
      this.hideHint()
    }
  }

  rememberFocus() {
    if (!this.focusKeyValue) return
    if (document.activeElement === this.inputTarget) {
      sessionStorage.setItem(this.focusKeyValue, "1")
    }
  }

  restoreFocus() {
    if (!this.focusKeyValue) return
    if (sessionStorage.getItem(this.focusKeyValue) === "1") {
      sessionStorage.removeItem(this.focusKeyValue)
      this.inputTarget.focus()
      this.inputTarget.setSelectionRange(this.inputTarget.value.length, this.inputTarget.value.length)
    }
  }

  showHint() {
    if (this.hasHintTarget) this.hintTarget.classList.remove("d-none")
  }

  hideHint() {
    if (this.hasHintTarget) this.hintTarget.classList.add("d-none")
  }
}
